import React from "react";
import bg from "../../../assets/FinalAnnexureBG.jpg";
import classNames from "classnames";

const TableHeadingPage = ({ isPdf }) => {
  return (
    <div
      className={classNames(
        " pdfSection  w-full flex items-center justify-center ",
        isPdf ? "h-[100svh]" : "h-full p-2",
      )}
    >
      <div
        key="tables-divider-pdf"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="h-full  w-full flex items-center justify-center"
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#EABC9D] italic playfair">
          Annexure
        </h2>
      </div>
    </div>
  );
};

export default TableHeadingPage;
